// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"OutstandingTable_pageTitle__qNu4x","tableSection":"OutstandingTable_tableSection__UUcBv","action":"OutstandingTable_action__2o_ib"};